import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { SampleDataService } from '../../data-services/sample/sample.data.service';
import { ActivityService } from '../../services/activity/activity.service';
import { DeviceService } from '../../services/device/device.service';
import { SampleService } from '../../services/sample/sample.service';
import { RepServices } from '../../data-services/rep/rep.services';
import { TrackService, TrackingEventNames } from '../../services/logging/tracking.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../services/notification/notification.service';
import { AlertService } from '../../services/alert/alert.service';
import { SignaturePad } from '../shared/signaturepad/angular2-signaturepad.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Generated class for the CaptureSignatureModalComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'capture-signature-popover',
  templateUrl: 'capture-signature-popover.html',
  styleUrls:['capture-signature-popover.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class CaptureSignaturePopoverComponent implements OnInit, OnDestroy {
  @ViewChild('sigPad', {static: false}) signaturePad: SignaturePad;
  @Input() confirmMessage;
  @Input() confirmTitle;
  @Input() skipToConfirmationPopup = false;
  @Input() from = '';
  @Input() rawTermsBody = '';
  @Input() agreementMessage = '';
  @Input() readOnlySignature = '';
  public submitEnable = false;
  public termsBody: SafeHtml = null;
  public signaturePadOptions = {
    minWidth: 0.5,
    canvasWidth: 300,
    canvasHeight: 200,
    scaleRatio: 1.5, // 3:2 ratio to fit in Dynamics
    backgroundColor: '#ffffff'
  };
  constructor(
    public loadingCtrl: LoadingController,
    public sampleDataService: SampleDataService,
    public activityService: ActivityService,
    public notificationService: NotificationService,
    public readonly repService: RepServices,
    public sampleService: SampleService,
    private readonly alertService: AlertService,
    public trackingService: TrackService,
    public readonly translate: TranslateService,
    private readonly _cd: ChangeDetectorRef,
    public modalCtrl: ModalController,
    public device: DeviceService,
    private readonly sanitizer: DomSanitizer,
  ) {
    if (this.device.isMobileDevicePortrait) {
      this.signaturePadOptions.canvasWidth = Math.floor(window.innerWidth * 0.9);
    } else if (this.device.isMobileDevice) {
      this.signaturePadOptions.canvasWidth = Math.floor(window.innerWidth * 0.67);
    } else {
      this.signaturePadOptions.canvasWidth = 550;
    }
  }

  ngOnInit() {
    if (this.rawTermsBody) {
      try {
        this.termsBody = this.sanitizer.bypassSecurityTrustHtml(this.rawTermsBody);
      } catch {
        this.termsBody = null;
      }
    }
    // Lock to current orientation while signature pad is open (Electron only)
    if (this.device.isElectron()) {
      (window as any).electron?.send('lock-orientation');
    }
  }

  ngOnDestroy() {
    // Unlock orientation when signature pad is dismissed
    if (this.device.isElectron()) {
      (window as any).electron?.send('unlock-orientation');
    }
  }

  drawStart(){
    console.log('detected signature pad draw start');
  }
  drawComplete(){
    this.submitEnable = true;
    this._cd.markForCheck();
    this._cd.detectChanges();
  }
  clearDraw(){
    this.signaturePad.clear();
    this.submitEnable = false;
    this._cd.markForCheck();
    this._cd.detectChanges();
  }
  closePopover(){
    this.modalCtrl.dismiss({completedFlow: false});
  }

  openConfirmationPopup() {
    if(this.skipToConfirmationPopup) {
      this.submitDraw();
      return;
    }
    const confirmationMessage = this.confirmMessage ? this.confirmMessage : '';
    const confirmationTitle = this.confirmTitle ? this.confirmTitle : '';

    this.alertService.showAlert({
      title: confirmationTitle,
      message: confirmationMessage}, this.translate.instant('SUBMIT')
    ).then (res => {
      if(res.role === 'ok') {
        this.submitDraw();
      }
    });
  }

  async submitDraw () {
    if (this.from && this.from == 'CaptureAllocationOrderComponent') {
      await this.trackingService.tracking('AllocationOrderSignatureSubmit',TrackingEventNames.ALLOCATIONS, null, true);
    }
    const signatureData = this.signaturePad.toDataURL('image/jpeg', 0.8);
    await this.modalCtrl.dismiss({completedFlow: true, signatureData:signatureData});
  }
}
